// removes really annoying safari auto zoom when clicking on inputs
const updateViewportMeta = () => {
  let meta = document.querySelector('meta[name="viewport"]');

  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "viewport";
    document.head.appendChild(meta);
  }

  meta.content =
    "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
};

updateViewportMeta();

// remove default margin and padding on html and body
document.documentElement.style.margin = "0";
document.documentElement.style.padding = "0";
document.body.style.margin = "0";
document.body.style.padding = "0";

// polyfill for HTMLDialogElement (safari)
if (typeof window !== "undefined") {
  if (typeof window.HTMLDialogElement === "undefined") {
    window.HTMLDialogElement = function () {};
  }
}

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { theme } from "./theme";
import { MantineProvider } from "@mantine/core";
import { initAnalytics } from "./mini-get-a-quote/analytics/analytics";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "./index.css";

const fontStyle = document.createElement("style");
fontStyle.innerHTML = `
  @font-face {
    font-family: "Avenir Next";
    src: url("/fonts/avenir-next-regular.woff2") format("woff2");
    font-weight: 400;
  }
  @font-face {
    font-family: "Avenir Next";
    src: url("/fonts/avenir-next-demi.woff2") format("woff2");
    font-weight: 600;
  }
  
  /* Force it onto the container */
  #mini-get-a-quote {
    font-family: "Avenir Next", sans-serif !important;
  }
`;
document.head.appendChild(fontStyle);

function getMountNode() {
  return document.querySelector(".hero__search-card");
}

function getFallbackNode() {
  return document.getElementById("mini-get-a-quote");
}

let hasMounted = false;

function mount() {
  if (hasMounted) return;

  const mountNode = getMountNode();
  const fallbackNode = getFallbackNode();

  if (!mountNode && !fallbackNode) {
    console.warn("No mount node found yet, retrying...");
    setTimeout(mount, 50);
    return;
  }

  const target = mountNode || fallbackNode;

  hasMounted = true;

  const heroLogo = document.querySelector(".hero__logos");

  if (heroLogo) {
    heroLogo.style.zIndex = "0";
  }

  ReactDOM.createRoot(target).render(
    <React.StrictMode>
      <MantineProvider
        theme={theme}
        cssVariablesSelector="#mini-get-a-quote"
        getRootElement={() => target}
        defaultProps={{
          Portal: {
            target,
          },
        }}
        deduplicateCssVariables={false}
      >
        <App />
      </MantineProvider>
    </React.StrictMode>,
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}
